// | Wrapper around (Ratio Int) providing Decode and Encode instances. For use
// | primarily in transport types.
import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRatio from "../Data.Ratio/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Rational = x => x;
const udecodeRational = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "denominator"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "numerator"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy));
    return x => {
      const $1 = $0(x);
      return Data$dRatio.reduce(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)($1.numerator)($1.denominator);
    };
  })()
};
const showRational = {show: v => Data$dShow.showIntImpl(v._1) + " % " + Data$dShow.showIntImpl(v._2)};
const semiringRational = /* #__PURE__ */ Data$dRatio.semiringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt);
const ringRational = /* #__PURE__ */ Data$dRatio.ringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt);
const ordRational = /* #__PURE__ */ Data$dRatio.ordRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt);
const newtypeRational = {Coercible0: () => {}};
const euclideanRingRational = /* #__PURE__ */ Data$dRatio.euclideanRingRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt);
const eqRational = {eq: v => v1 => v._1 === v1._1 && v._2 === v1._2};
const encodeRational = {
  encode: v => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "numerator"})({
    encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce
  }))({reflectSymbol: () => "denominator"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
    numerator: v._1,
    denominator: v._2
  })
};
const divisionRingRational = {recip: v => Data$dRatio.$Ratio(v._2, v._1), Ring0: () => Data$dRatio.ringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)};
const decodeRational = {
  decode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "numerator"
    })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "denominator"})({
      decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
    })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
      if ($1.tag === "Right") {
        return Data$dEither.$Either("Right", Data$dRatio.reduce(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)($1._1.numerator)($1._1.denominator));
      }
      $runtime.fail();
    };
  })()
};
const commutativeRingRational = {Ring0: () => Data$dRatio.ringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)};
export {
  Rational,
  commutativeRingRational,
  decodeRational,
  divisionRingRational,
  encodeRational,
  eqRational,
  euclideanRingRational,
  newtypeRational,
  ordRational,
  ringRational,
  semiringRational,
  showRational,
  udecodeRational
};
